import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { co } from '@fullcalendar/core/internal-common';
import { ConfirmationService, MessageService } from 'primeng/api';
import { actualizarEstOperacionRequest, InsertVEN_DOCVSI_UnRegANDVEN_DDOVSI_UnRegRequest, ItemActualizar, paObtieneOperacionesLogisticasPorPreFacturar, paObtieneOperacionesLogisticasPorPreFacturarDetallado, paObtieneOperacionesLogisticasPorPreFacturarRequest } from 'src/app/operacion/operacion/control-ovs/domain/control-ovs.request';
import { OperacionRepository } from 'src/app/repositorio/operacion.repository';
import { Parametros } from 'src/app/services/domain/services-domain';
import { StorageService } from 'src/app/services/storage.service';
import { UtilService } from 'src/app/services/util.service';
import { readonlyMetadataTable } from 'src/app/shared/components/readonly-data-table/domain/readonly-data-table.domain';
import { DetalleServiciosLocalesRequest, GenerarOrdenServicioRequest, TransaccionAgrupadorRequest } from '../../domain/request/comercial-orden-venta-request';
import { ComercialRepository } from 'src/app/repositorio/comercial.repository';
import { switchMap } from 'rxjs';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { getSerieFacturacionRequest } from 'src/app/finanzas/cobranzas/domain/request/request_facturaventa';
import { CobranzasRepository } from 'src/app/finanzas/cobranzas/domain/cobranzas_repository';

@Component({
  selector: 'app-prefacturacion',
  templateUrl: './prefacturacion.component.html',
  styleUrl: './prefacturacion.component.css',
  providers: [MessageService],
})
export class PrefacturacionComponent {
  constructor(private readonly servOperaciones: OperacionRepository,
    private util: UtilService,
    private confirmationService: ConfirmationService,
    private readonly storage: StorageService,
    public messageService: MessageService,
    private readonly ordenventaService: ComercialRepository,
    private readonly FinanzasService: CobranzasRepository,
  ) { }
  @Output() onProcesado = new EventEmitter<any>();
  @Input() data: any;

  group: FormGroup;
  ListaTipoComprobante: any[] = []
  ListaSerieComprobante: any[] = []
  ListaMoneda: any[] = []
  ListaFormaPago: any[] = []
  parametros: Parametros[] = []
  tablaSeleccionados: any[] = []
  tablaPrefactura: any[] = []
  sldetrequest: any[] = []
  datatablePreFac1: any[] = []
  datatablePreFac2: any[] = []
  copeCodigo: null;
  tablaOrdenVenta: any[] = []
  metadatatablePreFac2: newmetadate[] = [
    { field: 'dope_item', title: 'ITEM', inputType: 'text' },
    { field: 'serv_nombre_spa', title: 'SERVICIO', inputType: 'text' },
    { field: 'dope_preciototcosto', title: 'IMPORTE COSTO', inputType: 'text' },
    { field: 'dope_preciototvta', title: 'IMPORTE VENTA', inputType: 'text' },
    // { field: '', title: 'VALOR IGV', inputType: 'text' },
    // { field: '', title: 'IMPUESTO', inputType: 'text' },
    // { field: '', title: 'VALOR TOTAL', inputType: 'text' },
  ];
  data_operacion: any;

  iniciarFormulario() {
    this.group = new FormGroup({
      tipocomprobante: new FormControl("001", null),//solamente deben ser estos: '001','003','007','100','105'
      seriecomprobante: new FormControl(null, null),
      fechaemision: new FormControl(new Date, null),
      cod_lng: new FormControl(null, null),
      // moneda: new FormControl(null, null),
      // formapago: new FormControl(null, null),
      // diascredito: new FormControl(null, null),
      // fechavencimiento: new FormControl(null, null),
      // viaje: new FormControl(null, null)
    })
    // this.ListaSerieComprobante = this.parametros.slice().filter(r => r.tipo == 'SERIECOMPROBANTEFACTURA' && (r.codigo === "26" || r.codigo === "28" || r.codigo === "000"))
  }

  async ngOnInit(): Promise<void> {
    await this.iniciarFormulario()
    if (this.data) {
      const datos = this.data;
      this.data_operacion = datos.operacion;
      this.group.get('cod_lng').setValue(datos.cod_lng);
    }
    this.parametros = await this.util.getParametros()
    this.listarParametros()
    this.tablaSeleccionados = []
    if (localStorage.getItem("copeCodigo") != null) {
      const copeCodigo = localStorage.getItem("copeCodigo");
      const datos = JSON.parse(copeCodigo);
      localStorage.removeItem('copeCodigo');
      this.copeCodigo = datos
      console.log('this.copeCodigo', this.copeCodigo);
    }
    if (localStorage.getItem("dataservicio") != null) {
      const dataservicio = localStorage.getItem("dataservicio");
      const table = JSON.parse(dataservicio);
      localStorage.removeItem('table');
      this.tablaSeleccionados = table
      console.log('this.tablaSeleccionados', this.tablaSeleccionados);
    }
    if (localStorage.getItem("dataov") != null) {
      const dataov = localStorage.getItem("dataov");
      const table = JSON.parse(dataov);
      localStorage.removeItem('table');
      this.tablaOrdenVenta = table
      console.log('this.tablaOrdenVenta', this.tablaOrdenVenta);
    }
    this.consultarOpePendientes()
  }

  async listarParametros() {
    this.ListaTipoComprobante = this.parametros.slice().filter(r =>
      r.tipo === 'TDO' && (r.codigo === "001" || r.codigo === "003" || r.codigo === "007" || r.codigo === "100" || r.codigo === "105"));
    // this.ListaSerieComprobante = this.parametros.slice().filter(r =>
    //   r.tipo === 'SERIECOMPROBANTEFACTURA' && (r.codigo === "26" || r.codigo === "28"));
    // this.ListaSerieComprobante.unshift({ codigo: "000", nombre: "-Seleccionar-" });
  }

  PanelConfirmacionMantenimiento(mensaje, row: any, funcion: (dato: any) => void) {
    this.confirmationService.confirm({
      target: event.target,
      message: mensaje,
      key: "DT",
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Aceptar',
      },
      header: 'Confirmation',
      closable: false,
      closeOnEscape: false,
      accept: () => {
        funcion(row)
      },
      reject: () => {
      },
    });
  }

  formatoMessage: any
  InsertVEN_DOCVSI_UnRegANDVEN_DDOVSI_UnReg(Rows) {
    const request = <InsertVEN_DOCVSI_UnRegANDVEN_DDOVSI_UnRegRequest>{};
    request.listaPadresEHijos = Rows
    request.usuario = this.storage.get("usuario");
    request.codtipocomprobante = this.group.get('tipocomprobante').value;
    request.codserie = this.group.get('seriecomprobante').value;
    this.servOperaciones.InsertVEN_DOCVSI_UnRegANDVEN_DDOVSI_UnReg(request).subscribe(response => {
      if (response.datos.status = 200) {
        this.formatoMessage = { severity: 'success', summary: 'OK', detail: 'Se prefacturó correctamente.', life: 3000, key: 'tl' }
        const adicionales = this.datatablePreFac2.map(item => ({
          dope_item: item.dope_item,
          cope_codigo: item.cope_codigo
        }));
        const Request: GenerarOrdenServicioRequest = <GenerarOrdenServicioRequest>{}
        Request.servicios = adicionales
        Request.usuario = this.storage.get('usuario')
        this.ordenventaService.GenerarOrdenServicio(Request).subscribe(response => {
          if (response.datos.status === 200) {
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'OK', detail: 'Se registró correctamente la Orden de Servicio.', life: 3000, key: "tl" });
          } else {
            this.formatoMessage = { severity: 'warn', summary: 'Error', detail: response.meta.mensaje, life: 3000, key: 'tl' }
          }
        })
        this.onProcesado.emit(this.formatoMessage);
      }
    }, error => {
      // this.formatoMessage = { severity: 'warn', summary: 'Error', detail: error.error.meta.mensaje, life: 3000, key: 'tl' }
      this.util.MessageDialog({
        titulo: "Error en la prefacturación",
        mensaje: error.error.meta.mensaje,
        tipo: "warning",
        icono: 'pi pi-exclamation-triangle'
      });
    })
    console.log('Rows', Rows);
  }

  eleccionSerieComprobante(event) {
    switch (event.value) {
      case "001":
        this.ListaSerieComprobante = this.parametros.slice().filter(r => r.tipo == 'SERIECOMPROBANTEFACTURA' && (r.codigo === "26" || r.codigo === "28" || r.codigo === "000"))
        break;
      case "003":
        this.ListaSerieComprobante = this.parametros.slice().filter(r => r.tipo == 'SERIECOMPROBANTEFACTURA' && (r.codigo === "18" || r.codigo === "20" || r.codigo === "000"))
        break;
      case "007":
        this.ListaSerieComprobante = this.parametros.slice().filter(r => r.tipo == 'SERIECOMPROBANTEFACTURA' && (r.codigo === "22" || r.codigo === "24" || r.codigo === "30" || r.codigo === "32" || r.codigo === "000"))
        break;
      case "100":
        this.ListaSerieComprobante = []
        break;
      case "105":
        this.ListaSerieComprobante = []
        break;
      default:
        break;
    }
  }

  ver(event) {
    console.log(event)
  }

  consultarOpePendientes() {
    const request = <paObtieneOperacionesLogisticasPorPreFacturarRequest>{}
    request.cope_codigo_list = this.copeCodigo
    request.tipo_codmnd = '002'
    this.datatablePreFac1 = []
    this.datatablePreFac2 = []
    this.tablaPrefactura = []
    this.ordenventaService.ConsultaOPLogisticasPorPrefacturar(request).subscribe(response => {
      if (response.datos.status === 200) {
        const result = response.datos.result;
        console.log('result', result)
        this.tablaPrefactura = result.map(item => ({
          ...item,
          listadonavedetalle: Array.isArray(item['listadonavedetalle'])
            ? item['listadonavedetalle'].filter(det =>
              this.tablaSeleccionados.some(sel => Number(sel.dope_item) === Number(det.dope_item))
            ) : []
        }));
        const tipDoc = result[0]?.tipdoc;
        if (tipDoc === 'NC') {
          this.group.get('tipocomprobante')?.setValue('007'); // Nota de crédito
          this.getListaSerie(2);
          // this.group.get('seriecomprobante')?.setValue('003');
        } else {
          // this.group.get('tipocomprobante')?.setValue('001'); // Factura
          const elementoSeleccionado = this.ListaTipoComprobante[0];
          const valorParaAsignar = elementoSeleccionado.codigo;
          this.group.get('tipocomprobante')?.setValue(valorParaAsignar);

          this.getListaSerie(0);
        }
        console.log('this.tablaPrefactura filtrada', this.tablaPrefactura);

        const sumValorVenta: number = this.tablaPrefactura.reduce((sum, item) => sum + item.valorventa, 0);
        const sumValorTotal: number = this.tablaPrefactura.reduce((sum, item) => sum + item.valortotal, 0);
        if (sumValorTotal > 0) {
          this.tablaPrefactura = this.tablaPrefactura.filter(item => item.valortotal !== 0);
        }

        this.datatablePreFac1 = this.tablaPrefactura;
        this.datatablePreFac2 = this.tablaPrefactura.flatMap(item => item.listadonavedetalle);

        if (sumValorVenta === 0) {

          const request = <actualizarEstOperacionRequest>{}
          const itemsToUpdate: ItemActualizar[] = this.datatablePreFac2.map(row => {
            return {
              dope_item: Number(row.dope_item),
              cope_codigo: this.copeCodigo
            };
          });

          request.estado = '002';
          request.usuario = this.storage.get('usuario');
          request.items = itemsToUpdate;
          this.servOperaciones.ActualizarDetEstOperacion(request).subscribe(response => {
            if (response.datos.status === 200) {
              this.formatoMessage = { severity: 'success', summary: 'OK', detail: "El proceso ha finalizado satisfactoriamente", life: 3000, key: 'tl' }
              this.onProcesado.emit(this.formatoMessage);
            }
          }, err => {
            const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
            this.formatoMessage = { severity: 'warn', summary: 'Error', detail: mensaje, life: 3000, key: 'tl' }
            this.onProcesado.emit(this.formatoMessage);
          }
          );

        }
      }
    }, error => {
      this.formatoMessage = { severity: 'warn', summary: 'Error', detail: 'No hay operaciones para consultar.', life: 3000, key: 'tl' }
    }
    );
  }

  async getListaSerie(i: number) {
    if (this.data_operacion) {
      const reqSerie = <getSerieFacturacionRequest>{};
      reqSerie.cod_tdo = this.group.get('tipocomprobante').value;
      reqSerie.cod_lng = this.group.get('cod_lng')?.value;//this.data_operacion.cod_lng;
      this.FinanzasService.getListaSerieFacturacion(reqSerie).subscribe(res => {
        this.ListaSerieComprobante = res.datos.result.map(item => {
          const valorSerie = item.seri_serie;
          return {
            nombre: valorSerie,
            codigo: valorSerie
          };
        });
        if (i != null) {
          const elementoSeleccionado = this.ListaSerieComprobante[i];
          const valorParaAsignar = elementoSeleccionado.codigo;
          this.group.get('seriecomprobante')?.setValue(valorParaAsignar);
        }
      });
    }
  }

}
